import React from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/pages/trade-mobile.scss';
import InstrumentMobile from '../../components/Instrument/Instrument.mobile';
import RightArrowIcon from '@/assets/images/icons/mobiles/currentaccount_icon@2x.png';
import PortfolioIc from '@/assets/images/icons/mobiles/ic_order_portfolio.svg';
import OrderBookIc from '@/assets/images/icons/mobiles/ic_order_book.svg';
import OrderHistoryIc from '@/assets/images/icons/mobiles/ic_order_history.svg';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import PortfolioMobile from '@/components/MyAccount/Portfolio/Portfolio.mobile'


class TradeMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { language, currentTradingAccount ,topBarItem } = this.props;
    return (
      <React.Fragment>
        <div className='place-order-mobile-container'>
        <InstrumentMobile bidask TradeDashboard={true}/>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
  })
)(TradeMobile)
